import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Card from "../../components/common/Card";
import Button from "../../components/common/Button";
import Alert from "../../components/common/Alert";

const LicenseExpired = () => {
  const licenseState = useSelector((state) => state.license);
  const message =
    licenseState?.message || "License expired. Please renew to continue.";

  return (
    <div className="min-h-screen bg-[#f3f4f6] px-4 py-12">
      <div className="mx-auto w-full max-w-xl sm:p-10">
        <Card>
          <h1 className="text-center text-2xl font-semibold text-slate-900">
            License Expired
          </h1>
          <p className="mt-2 text-center text-sm text-slate-600">
            Your subscription license has expired or is not valid.
          </p>

          <div className="mt-6">
            <Alert tone="error">{message}</Alert>
          </div>

          <div className="mt-6 text-center text-sm text-slate-600">
            Please contact your platform administrator to renew the license.
          </div>

          <div className="mt-8 flex justify-center">
            <Link to="/login">
              <Button variant="secondary">Back to Login</Button>
            </Link>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default LicenseExpired;
